import React from 'react';
import { Link } from 'react-router-dom';
import Picture from './Picture';

const LOGO_URL = '/images/glossop_rt_logo_alt.png';

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & About */}
          <div className="-mt-1">
            <Picture
              src={LOGO_URL}
              alt="Glossop & District Round Table 916"
              className="w-full max-w-[280px] h-auto mb-6"
            />
            <p className="text-sm text-zinc-400 leading-relaxed">
              Glossop & District Round Table 916 — Fun, Friendship and Fundraising since 1927.
            </p>
            <div className="flex gap-4 mt-5">
              <a href="https://www.facebook.com/glossoprt?locale=en_GB" target="_blank" rel="noopener noreferrer" data-testid="footer-social-facebook" className="text-zinc-500 hover:text-[#F0A500] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.instagram.com/glossoproundtable916/" target="_blank" rel="noopener noreferrer" data-testid="footer-social-instagram" className="text-zinc-500 hover:text-[#F0A500] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://x.com/GlossopRT" target="_blank" rel="noopener noreferrer" data-testid="footer-social-twitter" className="text-zinc-500 hover:text-[#F0A500] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
              <a href="https://www.tiktok.com/@glossoproundtable" target="_blank" rel="noopener noreferrer" data-testid="footer-social-tiktok" className="text-zinc-500 hover:text-[#F0A500] transition-colors">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F0A500] mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link data-testid="footer-link-home" to="/" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-about" to="/about" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-membership" to="/membership" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Membership
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-benefits" to="/member-benefits" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Member Benefits
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-news" to="/news" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  News
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-events" to="/events" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Events
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-heritage" to="/heritage-programme" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Heritage Weekend
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-glossfest" to="/glossfest" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  GlossFest
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-bonfire" to="/bonfire" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Bonfire Night
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-sitemap" to="/sitemap" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Sitemap
                </Link>
              </li>
            </ul>
          </div>

          {/* Policies */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F0A500] mb-6">
              Policies
            </h4>
            <ul className="space-y-3">
              <li>
                <Link data-testid="footer-link-data-protection" to="/policies/data-protection" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Data Protection
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-cookies" to="/policies/cookies" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Cookies
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-anti-slavery" to="/policies/anti-slavery" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Anti-Slavery
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-anti-bribery" to="/policies/anti-bribery" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Anti-Bribery
                </Link>
              </li>
              <li>
                <Link data-testid="footer-link-anti-racism" to="/policies/anti-racism" className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors">
                  Anti-Racism
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F0A500] mb-6">
              Get In Touch
            </h4>
            <ul className="space-y-3">
              <li>
                <a
                  data-testid="footer-info-email-link"
                  href="mailto:info@glossoproundtable.org"
                  className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors"
                >
                  info@glossoproundtable.org
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href="mailto:membership@glossoproundtable.org"
                  className="text-sm text-zinc-400 hover:text-[#F0A500] transition-colors"
                >
                  membership@glossoproundtable.org
                </a>
              </li>
              <li className="pt-4">
                <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-[#F0A500] mb-3">
                  The Round Table Family
                </h4>
                <div className="flex flex-wrap gap-3">
                  <a href="https://www.roundtable.co.uk" target="_blank" rel="noopener noreferrer" className="text-xs text-zinc-500 hover:text-[#F0A500] transition-colors">
                    Round Table
                  </a>
                  <a href="http://www.ladiescircle.co.uk/" target="_blank" rel="noopener noreferrer" className="text-xs text-zinc-500 hover:text-[#F0A500] transition-colors">
                    Ladies Circle
                  </a>
                  <a href="http://41club.org/" target="_blank" rel="noopener noreferrer" className="text-xs text-zinc-500 hover:text-[#F0A500] transition-colors">
                    41 Club
                  </a>
                  <a href="https://www.tangent-clubs.org/" target="_blank" rel="noopener noreferrer" className="text-xs text-zinc-500 hover:text-[#F0A500] transition-colors">
                    Tangent
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-zinc-800 mt-12 pt-8 text-center space-y-2">
          <p className="text-xs text-zinc-500">
            &copy; {new Date().getFullYear()} Glossop & District Round Table 916. All rights reserved.
          </p>
          <p className="text-xs text-zinc-600">
            Designed and developed by{' '}
            <a href="https://www.bincon.net" target="_blank" rel="noopener noreferrer" className="text-[#F0A500] hover:text-[#D99500] font-semibold transition-colors">
              Binary Consultancy Limited
            </a>
          </p>
          <p className="text-[11px] text-zinc-700">
            Round Table Bar hero photo by{' '}
            <a
              href="https://www.pexels.com/photo/wooden-bar-counter-12360540/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-zinc-500 transition-colors"
            >
              Pexels
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
